import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordPages";
import { AcceptInvite, AccountPaused } from "@/pages/InvitePages";
import Dashboard from "@/pages/Dashboard";
import NewScan from "@/pages/NewScan";
import Opportunities from "@/pages/Opportunities";
import VehicleDetail from "@/pages/VehicleDetail";
import Watchlist from "@/pages/Watchlist";
import ScanHistory from "@/pages/ScanHistory";
import MarketData from "@/pages/MarketData";
import Co2Reference from "@/pages/Co2Reference";
import Settings from "@/pages/Settings";
import Integrations from "@/pages/Integrations";
import Subscription from "@/pages/Subscription";
import { PaymentCancelled, PaymentSuccess } from "@/pages/PaymentPages";
import Admin from "@/pages/Admin";
import Help from "@/pages/Help";

const Checking = () => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50 text-[13px] text-slate-500">
    Sessie controleren…
  </div>
);

const Protected = ({ children }) => {
  const { user, accessAllowed } = useAuth();
  if (user === null) return <Checking />;
  if (user === false) return <Navigate to="/login" replace />;
  // Een gepauzeerd account houdt zijn data, maar krijgt geen ImDash-functionaliteit.
  if (!accessAllowed) return <AccountPaused />;
  return children;
};

const MasterOnly = ({ children }) => {
  const { user, isMaster } = useAuth();
  if (user === null) return <Checking />;
  if (user === false) return <Navigate to="/login" replace />;
  if (!isMaster) return <Navigate to="/" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
};

const ROUTES = [
  ["/", <Dashboard />],
  ["/nieuwe-scan", <NewScan />],
  ["/handelskansen", <Opportunities />],
  ["/auto/:id", <VehicleDetail />],
  ["/watchlist", <Watchlist />],
  ["/scanhistorie", <ScanHistory />],
  ["/marktdata", <MarketData />],
  ["/co2-referentie", <Co2Reference />],
  ["/instellingen", <Settings />],
  ["/integraties", <Integrations />],
  ["/help", <Help />],
  ["/abonnement", <Subscription />],
  ["/betaling/geslaagd", <PaymentSuccess />],
  ["/betaling/geannuleerd", <PaymentCancelled />],
];

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicOnly>
                <Login />
              </PublicOnly>
            }
          />
          <Route path="/wachtwoord-vergeten" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/uitnodiging" element={<AcceptInvite />} />
          <Route
            path="/admin"
            element={
              <MasterOnly>
                <Admin />
              </MasterOnly>
            }
          />
          {ROUTES.map(([path, element]) => (
            <Route key={path} path={path} element={<Protected>{element}</Protected>} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
